export enum ColorPalette {
  PRIMARY = '#254B5A',
  ACCENT_MAIN = '#00223C',
  ACCENT_BLUE = '#99BAE3',
  ACCENT_DEFAULT_GREEN = '#8BB83A',
  WHITE = '#ffffff',
  GREY_MAIN = '#323F4B',
  GREY_400 = '#7B8794',
  GREY_300 = '#9AA5B1',
  GREY_200 = '#CBD2D9',
  GREY_100 = '#E3E7EB',
  GREY_50 = '#f0f4f8',
  GREY_0 = '#F5F7FA',
  GREY_DARK = '#171D23',
  POSITIVE_MAIN = '#6A983C',
  POSITIVE_400 = '#8C9C56',
  POSITIVE_300 = '#80A539',
  POSITIVE_200 = '#97B053',
  POSITIVE_100 = '#C0D120',
  NEGATIVE_MAIN = '#B00000',
  NEGATIVE_400 = '#C54545',
  NEGATIVE_200 = '#E28585',
  NEGATIVE_100 = '#FFCECE',
  WARNING_MAIN = '#775E00',
  WARNING_400 = '#CBA328',
  WARNING_200 = '#D3A914',
  WARNING_100 = '#F9DDAF',
  BLUE_MAIN = '#007EC3',
  VP_FORM_HOVER_STATE = '#004798',
  VP_NEUTRAL_STATE = '#888888',
  VP_NOT_RECOMMENDED_STATE = '#B91313',
  VP_RECOMMENDED_STATE = '#3E9142',
  VP_MODAL_BUTTON = '#CBE8C5',
}
